import LinkFormUX from "./pages";
import DuplicateDialogComponent from "./components/DuplicateDialog";
export default LinkFormUX;
export {resetLinkFormActionAtom} from "./states";
export {useLinkFormForUpdation, useLinkFormForCustomDomain, useLinkFormForDuplication} from "./hooks";
export const DuplicateDialog = DuplicateDialogComponent;